define(function () {
    return addViewabilityTracker;

    function addViewabilityTracker(adSlot, creativeId, viewabilityTracker) {
        adSlot.insertAdjacentHTML('beforeend', viewabilityTracker.replace('INSERT_UNIQUE_ID', creativeId));
    }
})



//////////////////
// WEBPACK FOOTER
// ./static/src/javascripts-legacy/projects/commercial/modules/creatives/add-viewability-tracker.js
// module id = 394
// module chunks = 1